import { FunctionComponent, useMemo, type CSSProperties, useEffect } from "react";

type NAVType = {
  dimensionCode?: string;

  /** Style props */
  navIconFlexShrink?: CSSProperties["flexShrink"];
};

const NAV: FunctionComponent<NAVType> = ({
  dimensionCode,
  navIconFlexShrink,
}) => {
  const frameDivStyle: CSSProperties = useMemo(() => {
    return {
      flexShrink: navIconFlexShrink,
    };
  }, [navIconFlexShrink]);

  return (
    <div
      className="still self-stretch flex flex-row items-center justify-between text-left text-[1.5rem] text-white font-nunito"
      style={frameDivStyle}
    >
      <img
        className="abs relative w-[3.75rem] h-[3.79rem] object-cover"
        alt=""
        src={dimensionCode}
      />
        <a target="_blank" className="cursor-pointer text-white no-underline ml-6 flex-1 rounded-7xl bg-gray-200 box-border h-[4.06rem] flex flex-col items-center justify-center  max-w-[18.75rem] border-[2px] border-solid border-white" href={"https://unityacademy.io/courses/self-improvement"}>
      <div>
        <div className="relative font-semibold">Back to Home</div>
      </div></a>
    </div>
  );
};

export default NAV;
